import { LockKeyhole } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import type { SubscriptionTier } from "@/types/projects";

type AffinityChartUpgradePromptProps = {
  onOpenEntities: () => void;
  onOpenLore: () => void;
  recommendedTier: SubscriptionTier | null;
};

export function AffinityChartUpgradePrompt({
  onOpenEntities,
  onOpenLore,
  recommendedTier,
}: AffinityChartUpgradePromptProps) {
  const { t } = useTranslation();

  return (
    <Card className="border-amber-300/60 bg-amber-50/80">
      <CardContent className="space-y-5 px-6 py-8">
        <div className="flex items-start gap-4">
          <div className="rounded-full bg-amber-200/80 p-3 text-amber-950">
            <LockKeyhole className="h-5 w-5" />
          </div>
          <div className="space-y-2">
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-amber-900">
              {t("affinityChart.locked.eyebrow")}
            </p>
            <h2 className="text-3xl text-foreground">{t("affinityChart.locked.title")}</h2>
            <p className="max-w-3xl leading-7 text-muted-foreground">
              {t("affinityChart.locked.body", {
                recommendedTier: recommendedTier
                  ? t(`common.tiers.${recommendedTier}`)
                  : t("common.tiers.crafter"),
              })}
            </p>
          </div>
        </div>

        <div className="rounded-[22px] border border-amber-300/50 bg-white/80 p-4 text-sm leading-7 text-amber-950">
          {t("affinityChart.locked.authoring")}
        </div>

        <div className="flex flex-wrap gap-3">
          <Button onClick={onOpenEntities} type="button">
            {t("affinityChart.actions.openEntities")}
          </Button>
          <Button onClick={onOpenLore} type="button" variant="outline">
            {t("affinityChart.actions.openLore")}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
